/* ============================================================
   DEELITE — bandeaux défilants infinis + calage de la barre du haut

   Le principe : on mesure la largeur réelle d'un groupe de mots,
   on en ajoute autant de copies que l'écran en réclame, puis on
   fait glisser la piste d'exactement une largeur de groupe. Au
   moment où l'animation reboucle, la copie suivante est déjà
   pile au même endroit : la couture est invisible et le bandeau
   ne se vide jamais, même sur un très grand moniteur.

   La vitesse est réglée en pixels/seconde depuis l'éditeur, donc
   elle est la même sur un téléphone et sur un 27 pouces.
   ============================================================ */
(function () {
  if (window.DNL_MQ) return;
  window.DNL_MQ = true;

  var DEFAULT_PPS = 55;

  function measure(el) {
    return el ? el.getBoundingClientRect().width : 0;
  }

  function build(root) {
    var track = root.querySelector("[data-dnl-mq-track]");
    if (!track) return;

    var groups = track.querySelectorAll(".dnl-mq-group");
    if (!groups.length) return;

    // on repart d'un seul groupe pour mesurer juste
    for (var i = groups.length - 1; i >= 1; i--) {
      track.removeChild(groups[i]);
    }

    var first = track.querySelector(".dnl-mq-group");
    var groupWidth = measure(first);
    var frameWidth = measure(root);
    if (!groupWidth || !frameWidth) return;

    // il faut de quoi couvrir l'écran plus un tour complet
    var copies = Math.max(2, Math.ceil(frameWidth / groupWidth) + 1);

    for (var j = 1; j < copies; j++) {
      var clone = first.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      // les copies ne doivent pas se faire passer pour des blocs
      // éditables, sinon l'éditeur de thème ne sait plus lequel viser
      var tagged = clone.querySelectorAll("[data-shopify-editor-block]");
      for (var k = 0; k < tagged.length; k++) {
        tagged[k].removeAttribute("data-shopify-editor-block");
      }
      track.appendChild(clone);
    }

    var pps = parseFloat(root.getAttribute("data-dnl-pps")) || DEFAULT_PPS;
    track.style.setProperty("--dnl-shift", groupWidth.toFixed(2) + "px");
    track.style.setProperty("--dnl-dur", (groupWidth / pps).toFixed(2) + "s");
  }

  function buildAll(scope) {
    var list = (scope || document).querySelectorAll("[data-dnl-mq]");
    for (var i = 0; i < list.length; i++) build(list[i]);
  }

  // la barre du haut se cale sur la hauteur réelle du bandeau jaune
  // (et remonte toute seule si le bandeau est retiré du site)
  function syncAlert() {
    var alert = document.querySelector(".dnl-alert");
    var h = alert ? Math.round(alert.getBoundingClientRect().height) : 0;
    var value = h + "px";
    document.documentElement.style.setProperty("--dnl-alert-h", value);
    // on la pose aussi sur les elements concernes : plus sur que de
    // compter sur l'heritage depuis <html> selon les navigateurs
    var users = document.querySelectorAll(".dnl-topbar, .dnl-hero");
    for (var i = 0; i < users.length; i++) {
      users[i].style.setProperty("--dnl-alert-h", value);
    }
  }

  // Filet de securite pour les apparitions au scroll : si l'observateur
  // n'a rien declenche alors que du contenu est bien a l'ecran (onglet
  // ouvert en arriere-plan, navigateur capricieux), on affiche tout
  // plutot que de laisser une page blanche.
  function revealFallback() {
    var all = document.querySelectorAll(".dnl-reveal");
    if (!all.length) return;
    if (document.querySelector(".dnl-reveal.is-in")) return;

    var somethingOnScreen = false;
    for (var i = 0; i < all.length; i++) {
      var r = all[i].getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { somethingOnScreen = true; break; }
    }
    if (!somethingOnScreen) return;

    for (var j = 0; j < all.length; j++) all[j].classList.add("is-in");
  }

  var fallbackTimer = null;
  function scheduleFallback(delay) {
    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(revealFallback, delay);
  }

  scheduleFallback(2500);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") scheduleFallback(1200);
  });
  // au premier defilement aussi : c'est la que du contenu arrive a l'ecran
  window.addEventListener("scroll", function () {
    if (document.querySelector(".dnl-reveal.is-in")) return;
    scheduleFallback(600);
  }, { passive: true });

  function refresh() {
    syncAlert();
    buildAll();
  }

  // ---- déclenchements ----
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh);
  } else {
    refresh();
  }

  window.addEventListener("load", refresh);

  // les polices et les images changent la largeur mesurée
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refresh).catch(function () {});
  }

  // on ne recalcule qu'au vrai changement de largeur : sur mobile,
  // la barre d'adresse fait varier la hauteur en permanence
  var lastWidth = window.innerWidth;
  var timer = null;
  window.addEventListener("resize", function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(timer);
    timer = setTimeout(refresh, 180);
  });

  window.addEventListener("orientationchange", function () {
    clearTimeout(timer);
    timer = setTimeout(refresh, 300);
  });

  // éditeur de thème
  document.addEventListener("shopify:section:load", function () {
    setTimeout(refresh, 60);
  });
  document.addEventListener("shopify:block:select", function () {
    setTimeout(refresh, 60);
  });
})();
